import { FC } from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { email } from "../../../../constants/personalInfo/personalInfo.ts";
import { ReactComponent as EnvelopeIcon } from "../../../../assets/svg/contact/envelope-solid.svg";

const Contact: FC = () => {
    const {
        t
    } = useTranslation('footer');
    
    return (
        <Col
            md={6}
            sm={12}
            id="contact"
        >
            <h5>
                {t('contact.title')}
            </h5>
            <ul>
                <li>
                    <EnvelopeIcon />
                    <a 
                        href={"mailto:" + email}
                    >
                        {email}
                    </a>
                </li>
            </ul>
        </Col>
    )
};

export default Contact;